export const ONE_SERVICE_PROVIDER_RESET_STATE = 'ONE_SERVICE_PROVIDER_RESET_STATE';
export const ONE_SERVICE_PROVIDER_CURRENT_ITEM = 'ONE_SERVICE_PROVIDER_CURRENT_ITEM';

export const ONE_SERVICE_PROVIDER_REQUEST_LOADING = 'ONE_SERVICE_PROVIDER_REQUEST_LOADING';
export const ONE_SERVICE_PROVIDER_REQUEST_SUCCESS = 'ONE_SERVICE_PROVIDER_REQUEST_SUCCESS';
export const ONE_SERVICE_PROVIDER_REQUEST_FAILED = 'ONE_SERVICE_PROVIDER_REQUEST_FAILED';

export const ONE_SERVICE_PROVIDER_CURRENT_ACTION = 'ONE_SERVICE_PROVIDER_CURRENT_ACTION';
export const ONE_SERVICE_PROVIDER_RESET_ACTION = 'ONE_SERVICE_PROVIDER_RESET_ACTION';